import { render, staticRenderFns } from "./TeamDiscussion.vue?vue&type=template&id=21543568&scoped=true&lang=pug&"
import script from "./TeamDiscussion.vue?vue&type=script&lang=js&"
export * from "./TeamDiscussion.vue?vue&type=script&lang=js&"
import style0 from "./TeamDiscussion.vue?vue&type=style&index=0&id=21543568&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21543568",
  null
  
)

export default component.exports